
import React from 'react';
import ConnectionStatusIndicator from './mobile/ConnectionStatusIndicator';

interface ConnectionStatusProps {
  className?: string;
  compact?: boolean;
}

// Component now hidden per user's request
const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ className = '', compact = false }) => {
  // Simply return the now-empty ConnectionStatusIndicator component
  return <ConnectionStatusIndicator className={className} compact={compact} />;
};

export default ConnectionStatus;
